import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetAllLogisticsCarriersQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.LogisticsCarrierDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.LogisticsCarrierDocumentSortInput> | Types.LogisticsCarrierDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetAllLogisticsCarriersQuery = { __typename?: 'Query', logisticsCarriers?: { __typename?: 'LogisticsCarriersConnection', totalCount: number, nodes?: Array<{ __typename?: 'LogisticsCarrierDocument', id: string, tenantId: string, carrierId: string, name: string, type: Types.CarrierType, contactName: string, contactEmail: string, contactPhone: string, dotNumber: string, mcNumber: string, isActive: boolean, notes: string, rateBasis: Types.CarrierRateBasis, rateAmount?: number | null, fuelSurchargePercent?: number | null, updatedAt: Types.TDateISO, updatedBy: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type LogisticsCarrierDocumentFieldsFragment = { __typename?: 'LogisticsCarrierDocument', id: string, tenantId: string, carrierId: string, name: string, type: Types.CarrierType, contactName: string, contactEmail: string, contactPhone: string, dotNumber: string, mcNumber: string, isActive: boolean, notes: string, rateBasis: Types.CarrierRateBasis, rateAmount?: number | null, fuelSurchargePercent?: number | null, updatedAt: Types.TDateISO, updatedBy: string };

export const LogisticsCarrierDocumentFieldsFragmentDoc = new TypedDocumentString(`
    fragment LogisticsCarrierDocumentFields on LogisticsCarrierDocument {
  id
  tenantId
  carrierId
  name
  type
  contactName
  contactEmail
  contactPhone
  dotNumber
  mcNumber
  isActive
  notes
  rateBasis
  rateAmount
  fuelSurchargePercent
  updatedAt
  updatedBy
}
    `, {"fragmentName":"LogisticsCarrierDocumentFields"});
export const GetAllLogisticsCarriersDocument = new TypedDocumentString(`
    query GetAllLogisticsCarriers($where: LogisticsCarrierDocumentFilterInput, $order: [LogisticsCarrierDocumentSortInput!], $first: Int, $after: String, $last: Int, $before: String) {
  logisticsCarriers(
    where: $where
    order: $order
    first: $first
    last: $last
    before: $before
    after: $after
  ) {
    nodes {
      ...LogisticsCarrierDocumentFields
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment LogisticsCarrierDocumentFields on LogisticsCarrierDocument {
  id
  tenantId
  carrierId
  name
  type
  contactName
  contactEmail
  contactPhone
  dotNumber
  mcNumber
  isActive
  notes
  rateBasis
  rateAmount
  fuelSurchargePercent
  updatedAt
  updatedBy
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetAllLogisticsCarriers: build.query<GetAllLogisticsCarriersQuery, GetAllLogisticsCarriersQueryVariables | void>({
      query: (variables) => ({ document: GetAllLogisticsCarriersDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetAllLogisticsCarriersQuery, useLazyGetAllLogisticsCarriersQuery } = injectedRtkApi;
